import { createContextFactory } from '@streem/toolbox';
export const [HostRecentCallLogProvider, useHostRecentCallLog,] = createContextFactory('HostRecentCallLog');
//# sourceMappingURL=call_log.js.map